<template>
  <div class="tip-wrapper flex-sc">
    <div class="tip-left">
      <eui-icon class="data-icon" icon="eicon-wrong-press" color="#ea9200" />
    </div>
    <div class="tip-right">
      <div v-for="(item,index) in tipData" :key="index">
         <span class="tip-font">{{item}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tipMessage",
    props: {
      tipData: Array
    },
    data() {
      return {}
    },
  }
</script>

<style scoped lang="scss">
  .tip-wrapper {
    width: 100%;
    height: 44px;
    padding: 15px 10px;
    background-color: #FDEDEE;
    font-size: 14px;
    margin-bottom: 20px;

    .tip-left {
      color: #333;
      margin-right: 10px;
    }
    .tip-right{
      .tip-font{
        color: #333;
      }
    }

  }
</style>
